import { type CourseDetail } from "@client/content/modules/CourseDetail/types";
import { sort } from "@client/lib/array";
import { createSelector } from "reselect";
import { localStateSelector } from "../../../selectors";

const getLessonId = (course: CourseDetail.CourseAppState | null, direction: "previous" | "next"): string | null => {
  if (!course) return null;

  const lessons = sort(course.modules, { key: "sortOrder" }).reduce(
    (res, x) => [
      ...res,
      ...sort(
        course.lessons.filter((y) => y.moduleId === x.id && !y.isLocked),
        { key: "sortOrder" }
      )
    ],
    []
  );

  const index = lessons.findIndex((x) => x.id === course.activeLessonId);
  if (index === 0 && direction === "previous") return null;
  if (index === lessons.length - 1 && direction === "next") return null;

  return lessons[direction === "next" ? index + 1 : index - 1].id;
};

export const makePreviousLessonIdSelector = () => {
  return createSelector([localStateSelector], (localState) => getLessonId(localState.activeCourse, "previous"));
};

export const makeNextLessonIdSelector = () => {
  return createSelector([localStateSelector], (localState) => getLessonId(localState.activeCourse, "next"));
};
